"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosSupplierUpdateInputSchema = exports.APosSupplierCreateInputSchema = exports.APosSupplierSchema = exports.APosPaymentTermsSchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
const location_schema_1 = require("./location.schema");
exports.APosPaymentTermsSchema = zod_1.z.enum([
    'net_7', 'net_15', 'net_30', 'net_45', 'net_60',
    'cod', 'prepaid', 'on_account',
]);
exports.APosSupplierSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    supplierId: id_schema_1.EntityIdSchema,
    name: zod_1.z.string().min(1).max(150),
    code: zod_1.z.string().max(20).optional(),
    contactName: zod_1.z.string().max(100).optional(),
    email: zod_1.z.string().email().optional(),
    phone: zod_1.z.string().max(30).optional(),
    website: zod_1.z.string().url().optional(),
    address: location_schema_1.APosAddressSchema.optional(),
    paymentTerms: exports.APosPaymentTermsSchema.default('net_30'),
    leadTimeDays: zod_1.z.number().int().nonnegative().optional(),
    minimumOrderValue: zod_1.z.number().nonnegative().optional(),
    currency: zod_1.z.string().length(3).default('USD'),
    bankName: zod_1.z.string().optional(),
    bankAccountNumber: zod_1.z.string().optional(),
    bankRoutingNumber: zod_1.z.string().optional(),
    isActive: zod_1.z.boolean().default(true),
    totalOrders: zod_1.z.number().int().nonnegative().default(0),
    totalSpent: zod_1.z.number().nonnegative().default(0),
    lastOrderDate: zod_1.z.number().optional(),
    notes: zod_1.z.string().max(2000).optional(),
}).merge(timestamps_schema_1.TimestampsSchema);
exports.APosSupplierCreateInputSchema = zod_1.z.object({
    name: zod_1.z.string().min(1).max(150),
    code: zod_1.z.string().max(20).optional(),
    contactName: zod_1.z.string().max(100).optional(),
    email: zod_1.z.string().email().optional(),
    phone: zod_1.z.string().max(30).optional(),
    website: zod_1.z.string().url().optional(),
    address: location_schema_1.APosAddressSchema.optional(),
    paymentTerms: exports.APosPaymentTermsSchema.optional(),
    leadTimeDays: zod_1.z.number().int().nonnegative().optional(),
    minimumOrderValue: zod_1.z.number().nonnegative().optional(),
    currency: zod_1.z.string().length(3).optional(),
    notes: zod_1.z.string().max(2000).optional(),
});
exports.APosSupplierUpdateInputSchema = exports.APosSupplierCreateInputSchema.partial().extend({
    isActive: zod_1.z.boolean().optional(),
});
//# sourceMappingURL=supplier.schema.js.map